module.exports = __webpack_public_path__ + "img/proyecto8.631b9724.png";